import React from 'react';
import { useNavigate } from 'react-router-dom';
import {Helmet} from 'react-helmet';

import SecToday from './include/SecToday';
import SecSearch from './include/SecSearch';
import SecQuiz from './include/SecQuiz';
import SecBanner from './include/SecBanner';
import SecRenew from './include/SecRenew';

import Footer from './Footer';

 
const SecSearchWithLocation = () => {
  const navigate = useNavigate();
  return <SecSearch navigate={navigate} />;
};

function Main() {
  const structureData = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "지식포켓",
    "url": "https://pocket.asiae.co.kr/",
    "potentialAction": {
      "@type": "SearchAction",
      "target": "https://pocket.asiae.co.kr/Search/{search_term_string}",
      "query-input": "required name=search_term_string"
    }    
  }
  return (
    <>
      <Helmet>
          <title>지식포켓 - 오늘의 용어, 시사 퀴즈, 십자말풀이까지!</title>
          <meta name="keywords" content="지식포켓, 뉴스 용어, 시사 용어, 오늘의 용어, 용어 검색, OX 퀴즈, 객관식 퀴즈, 십자말풀이, 시사 상식, 뉴스 해설, 용어 사전" />
          <meta name="description" content="모르는 경제/시사 용어? 지식포켓에서 한 번에 해결! 용어 검색부터 퀴즈, 십자말풀이까지! 쉽고 빠르게 시사 상식을 쌓아보세요."/>

          <meta property="og:title" content="지식포켓 - 오늘의 용어, 시사 퀴즈, 십자말풀이까지!" />
          <meta property="og:description" content="모르는 경제/시사 용어? 지식포켓에서 한 번에 해결! 용어 검색부터 퀴즈, 십자말풀이까지! 쉽고 빠르게 시사 상식을 쌓아보세요."/>
          <meta property="og:url" content="https://pocket.asiae.co.kr/" />

          <link rel="canonical" href="https://pocket.asiae.co.kr/"/>
          <script type="application/ld+json">
          { JSON.stringify(structureData)}
          </script>
          
      </Helmet>     
      <main id="contents" data-page="main" className="page--main">
        <SecToday /><></>
        <SecSearchWithLocation />
        <SecQuiz />
        <SecBanner />
        <SecRenew />
        <Footer />
      </main>
    </>
  );
}

export default Main;